'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.default = function () {
    var $carouselActiveTab = (0, _jquery2.default)('.tab-pane.active [data-carousel]', this);
    var $carouselNoTabs = (0, _jquery2.default)('[data-carousel]').not('.tab-pane [data-carousel]', this);

    // select visible carousels
    var $carousels = $carouselNoTabs.add($carouselActiveTab);

    initMainCarousel($carousels);

    // HP teaser
    var $hpTeaserCarousel = (0, _jquery2.default)('#hpTeaser', document);
    if ($hpTeaserCarousel.length && !$hpTeaserCarousel.hasClass('slick-initialized')) {
        var setBackgroundImage = function setBackgroundImage($elm) {
            $elm.each(function () {
                var $this = (0, _jquery2.default)(this);
                if ((0, _linksoftAlbatros.isMaxWidth)('sm') && $this.hasClass('h-t__bg--mobile')) {
                    $this = $this.not('.h-t__bg--desktop');
                } else {
                    $this = $this.not('.h-t__bg--mobile');
                }

                // DOTO: check what happend
                // $this.css('background-image', 'url('+ $this.data('bg') +')');
            });
        };

        $hpTeaserCarousel.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
            // set bg for nex next invisble one for smooth switching
            setBackgroundImage((0, _jquery2.default)('a', slick.$slides.eq(nextSlide + 1)));
        });

        // first init
        $hpTeaserCarousel.on('init', function (e, slick) {
            // make first image load first!
            setBackgroundImage((0, _jquery2.default)('a', slick.$slides.eq(0)));

            // prevent image blink
            if (slick.$slides.length > 1) {
                (0, _jquery2.default)('.slick-cloned', $hpTeaserCarousel).each(function () {
                    setBackgroundImage((0, _jquery2.default)('a', this));
                });

                for (var i = 0; i < 2; ++i) {
                    setBackgroundImage((0, _jquery2.default)('a', slick.$slides.eq(i)));
                }
            }
        });

        $hpTeaserCarousel.slick({
            dots: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            autoplay: true,
            autoplaySpeed: 7000,
            appendArrows: $hpTeaserCarousel.parent().next()
        });
    }

    // HP catalog
    var $hpCatalog = (0, _jquery2.default)('#hpCatalogs', document);
    var hpCatalogSetting = {
        slidesToShow: 6,
        slidesToScroll: 6,
        infinity: false,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        appendArrows: $hpCatalog.next(),
        responsive: [{
            breakpoint: 1700,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5
            }
        }, {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 575,
            settings: {
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    };
    var cmsCatalogSetting = {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinity: false,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        appendArrows: $hpCatalog.next(),
        responsive: [{
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    };

    if ($hpCatalog.length && !$hpCatalog.hasClass('slick-initialized')) {

        var carouselSettingDefault = (0, _jquery2.default)('.cms-content #hpCatalogs', document).length ? cmsCatalogSetting : hpCatalogSetting;
        // return;
        $hpCatalog.slick(carouselSettingDefault);
    }

    window.unslickNewsCarouselGlobal = function () {
        var hpNews = (0, _jquery2.default)('#newsCarousel', document);
        hpNews.slick('unslick');
        (0, _jquery2.default)('.my-slide').remove();
    };

    // Make ti accessible from outside
    window.initSlickNewsCarouselGlobal = function () {
        initSlickCarousels();
    };
    function initSlickCarousels() {
        var hpNews = (0, _jquery2.default)('#newsCarousel', document);
        initSlickCarousel(hpNews);
    }

    initSlickCarousels();

    // Slick carousels
    var $HpCmsPageCarousel = (0, _jquery2.default)('#cmsPageCarousel', document);
    initSlickCarousel($HpCmsPageCarousel);

    function initSlickCarousel(carouselElement) {
        if (carouselElement.length && !carouselElement.hasClass('slick-initialized')) {
            carouselElement.slick({
                slidesToShow: 6,
                slidesToScroll: 6,
                infinity: false,
                mobileFirst: false,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                appendArrows: carouselElement.next(),
                responsive: [{
                    breakpoint: 1700,
                    settings: {
                        centerMode: true,
                        slidesToShow: 5,
                        slidesToScroll: 5
                    }
                }, {
                    breakpoint: 1400,
                    settings: {
                        centerMode: true,
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }, {
                    breakpoint: 1200,
                    settings: {
                        centerMode: true,
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        centerMode: true,
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 575,
                    settings: {
                        dots: false,
                        centerMode: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        }
    }

    // header banner carousel
    var $headBannerCarousel = (0, _jquery2.default)('#headBannerCarousel', document);
    if ($headBannerCarousel.length && !$headBannerCarousel.hasClass('slick-initialized')) {
        // return;
        $headBannerCarousel.slick({
            autoplay: true,
            autoplaySpeed: 7000,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            dots: true,
            arrows: false
        });
    }

    var $carouselSmall = (0, _jquery2.default)('.carousel--sm', document);
    if ($carouselSmall.length && !$carouselSmall.hasClass('slick-initialized')) {

        $carouselSmall.slick({
            dots: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            infinity: false,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            appendArrows: $carouselSmall.next(),
            responsive: [{
                breakpoint: 767,
                settings: {
                    variableWidth: true,
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }, {
                breakpoint: 575,
                settings: {
                    arrows: false,
                    dots: false,
                    variableWidth: true,
                    slidesToShow: 1
                }
            }]
        });
    }
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import './../utils/jquery-throttle-debounce';

var prevArrow = '<button class="arrow arrow--left">\n                    <svg width="100%" height="100%" viewBox="0 0 19 54">\n                        <path class="arrow-path" d="M17.707,0.707l-17,26l17,26"/>\n                    </svg>\n                    </button>';

var nextArrow = '<button class="arrow arrow--right">\n                   <svg width="100%" height="100%" viewBox="0 0 19 54">\n                       <path class="arrow-path" d="M0.707,52.707l17,-26l-17,-26"/>\n                   </svg></button>';

var carouselOpt = {
    dots: true,
    infinity: false,
    variableWidth: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [{
        breakpoint: 575,
        settings: {
            dots: false,
            centerMode: true
        }
    }]
};

function getVisibleItemsInRow($carousel) {
    return Math.floor($carousel.width() / (0, _jquery2.default)('.carousel__item', $carousel).outerWidth());
}

function isThereHiddenItems($carousel) {
    return (0, _jquery2.default)('.carousel__item', $carousel).length > getVisibleItemsInRow($carousel);
}

function slickOptSlideToShow($carousel) {
    var items = isThereHiddenItems($carousel) ? getVisibleItemsInRow($carousel) : (0, _jquery2.default)('.carousel__item', $carousel).length;

    return {
        appendArrows: $carousel.next(),
        slidesToShow: items,
        slidesToScroll: items
    };
}

// set carousel with for nice result
function setWidthForCarousel($carousel) {
    if ((0, _linksoftAlbatros.isMaxWidth)('xs')) return;

    var $carouselItems = (0, _jquery2.default)('.carousel__item', $carousel);
    var carouselItemWidth = $carouselItems.outerWidth();

    if (!isThereHiddenItems($carousel)) {
        $carousel.css('width', $carouselItems.length * carouselItemWidth);
    } else {
        $carousel.css('width', getVisibleItemsInRow($carousel) * carouselItemWidth);
    }
}

function initMainCarousel($carousels) {

    $carousels.each(function () {
        var $this = (0, _jquery2.default)(this);

        var optDefault = (0, _assign2.default)(slickOptSlideToShow($this), carouselOpt);

        setWidthForCarousel($this);

        if (!$this.hasClass('slick-initialized')) {
            $this.slick(optDefault);
        }

        // destroy and reinit carousel inside tabs,
        // when switch between tabs
        if ($this.closest('.tab-pane').length) {
            (0, _jquery2.default)('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                var $prevContent = (0, _jquery2.default)((0, _jquery2.default)(e.relatedTarget).attr('href'));
                var $activeContent = (0, _jquery2.default)((0, _jquery2.default)(e.target).attr('href'));
                var $newCarousel = (0, _jquery2.default)('[data-carousel]', $activeContent);

                (0, _jquery2.default)('.carousel__arrows', $activeContent).empty();

                var optForNew = (0, _assign2.default)(slickOptSlideToShow($newCarousel), carouselOpt);

                // destroy current carousel
                (0, _jquery2.default)('[data-carousel]', $prevContent).slick('unslick');

                setWidthForCarousel($newCarousel);

                $newCarousel.slick(optForNew);
            });
        }
    });
}

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/carousels.js
// module id = 639
// module chunks = 0